(ns renolit-roofing-service.view.session.code-verify
  (:require [dev.gethop.session.re-frame.cognito.action.register :as cognito.register]
            [malli.core :as m]
            [malli.transform :as mt]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.info-bar :as layout.info-bar]
            [renolit-roofing-service.layout.session :as layout.session]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.util :as util]
            [renolit-roofing-service.view :as view]
            [renolit-roofing-service.view.session.login :as view.login]))

(def ^:const view-context
  :code-verify-view)

(def ^:const route-config
  {:name [:code-verify]})

(def ^:const form-schema
  [:map
   [:verification-code
    [:string]]])

(rf/reg-event-fx
 ::verify-success
 (fn [_ _]
   {:dispatch [::nav/push-state (:name view.login/route-config)]}))

(rf/reg-event-fx
 ::verify-failure
 (fn [_ [_ reason]]
   {:dispatch-n [[::layout.info-bar/add-info-bar
                  {:context view-context
                   :disappear-in-ms 5000
                   :type :error
                   :msg-transl-kw
                   :error-msg.unknown}]
                 [::util/generic-error reason]]}))

(defn- on-form-submit
  [state]
  (let [credentials (m/encode form-schema @state mt/strip-extra-keys-transformer)
        form-errors (form.error/check-errors form-schema credentials)]
    (if form-errors
      (rf/dispatch [::form.error/register-errors view-context form-errors])
      (do (rf/dispatch [::form.error/clear-errors view-context])
          (rf/dispatch [::cognito.register/user-confirm-registration
                        (:verification-code credentials)
                        {:on-success-evt [::verify-success]
                         :on-failure-evt [::verify-failure]}])))))

(defn- main
  []
  (let [state (r/atom {})]
    (fn []
      [layout.session/layout
       [:<>
        [:div.session_main-description
         [:h3.session_main-description-title
          (t [:page.code-verify.title])]
         [:span.session_main-description-subtitle
          (t [:page.code-verify.subtitle])]
         [:br]
         [:span.session_main-description-subtitle
          (t [:page.code-verify.spam-warning])]]
        [:form.simple-form.login_form
         {:on-submit
          (fn [e]
            (.preventDefault e)
            (on-form-submit state))}
         [layout.form/item
          {:context view-context
           :type :input
           :state state
           :mandatory? true
           :path [:verification-code]
           :label-transl-kw :label.verification-code
           :schema [:string]}]
         [:div.simple-form__actions
          [:button.btn.btn--primary
           {:type :submit}
           (t [:button.verify])]]]
        [:div.simple-form__actions
         [:button.btn.btn--secondary
          {:on-click #(rf/dispatch [::cognito.register/resend-user-verification-code
                                    {:on-success-evt [::layout.info-bar/add-info-bar
                                                      {:context view-context
                                                       :type :success
                                                       :msg-transl-kw
                                                       :page.code-verify.successful-resend}]
                                     :on-failure-evt [::layout.info-bar/add-info-bar
                                                      {:context view-context
                                                       :type :error
                                                       :msg-transl-kw
                                                       :error-msg.unknown}]}])}
          (t [:button.resend-code])]]]])))

(defmethod view/view-display (:name route-config)
  [_]
  [main])
